export const SPOTLIGHT_CATEGORY_DEFINITIONS = [
  {
    slug: 'news',
    value: 'News',
    labelKey: 'ui.spotlight.categories.news',
  },
  {
    slug: 'comparisons',
    value: 'Comparisons',
    labelKey: 'ui.spotlight.categories.comparisons',
  },
  {
    slug: 'analysis',
    value: 'Analysis',
    labelKey: 'ui.spotlight.categories.analysis',
  },
  {
    slug: 'guides',
    value: 'Guides',
    labelKey: 'ui.spotlight.categories.guides',
  },
] as const satisfies ReadonlyArray<{
  slug: string;
  value: string;
  labelKey: string;
}>;

export type SpotlightCategoryDefinition = (typeof SPOTLIGHT_CATEGORY_DEFINITIONS)[number];
export type SpotlightCategoryValue = SpotlightCategoryDefinition['value'];

export function spotlightCategoryBySlug(raw: unknown): SpotlightCategoryDefinition | null {
  if (typeof raw !== 'string') return null;
  return (
    SPOTLIGHT_CATEGORY_DEFINITIONS.find(({ slug }) => slug === raw.trim().toLowerCase()) ?? null
  );
}

export function spotlightCategoryByValue(raw: unknown): SpotlightCategoryDefinition | null {
  if (typeof raw !== 'string') return null;
  return SPOTLIGHT_CATEGORY_DEFINITIONS.find(({ value }) => value === raw.trim()) ?? null;
}

export function resolveSpotlightCategory(input: {
  category?: unknown;
  slug?: unknown;
  title?: unknown;
}): SpotlightCategoryDefinition {
  const explicitCategory = spotlightCategoryByValue(input.category);
  if (explicitCategory) return explicitCategory;

  const slug = typeof input.slug === 'string' ? input.slug.trim().toLowerCase() : '';
  const title = typeof input.title === 'string' ? input.title.trim().toLowerCase() : '';
  if (slug.includes('-vs-veeso') || /\bvs\.?\s+veeso\b/.test(title)) {
    return spotlightCategoryByValue('Comparisons')!;
  }

  return spotlightCategoryByValue('News')!;
}
